<template>
  <div class="phone-number-input mb-3">
    <b v-if="label" class="form-label"> {{ label }} </b>

    <vue-tel-input v-model="phoneNumber" :disabled="disabled" :readonly="readonly" :input-options="{
      placeholder: label,
      disabled: disabled,
      readonly: readonly,
      styleClasses: 'form-control'
    }"  
    :dropdown-options="{
      showDialCodeInSelection: true,
      showFlags: true,
      showSearchBox: true,               
      searchBoxPlaceholder: 'Recherche...'  
    }"
     @on-input="handleInput" />

    <span v-if="errorMessage" class="text-danger">{{ errorMessage }}</span>
    <span class="text-danger" v-for="error in v?.$errors" :key="error.$uid">
      - {{ error.$message }} <br>
    </span>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, defineProps, defineEmits } from 'vue';
import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css'; // Correct path
const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  label: String,
  placeholder: {
    type: String,
    default: 'Enter phone number',
  },
  disabled: Boolean,
  readonly: Boolean,
  v: {
    type: Object,
  },
});

const phoneNumber = ref(props.modelValue);
const errorMessage = ref('');
const emits = defineEmits(['update:modelValue']);

// Triggered whenever the user types or the country changes
const handleInput = (formattedNumber: string, phoneObject: any) => {
  // If you want to store the clean E.164 international format (e.g., "+12015550123")
  const valueToEmit = phoneObject?.number || formattedNumber;

  // Alternatively, if you only want pure numbers without "+", uncomment below:
  // const valueToEmit = (phoneObject?.number || formattedNumber).replace(/\D/g, '');

  emits('update:modelValue', valueToEmit ?? '');
};

watch(() => props.modelValue, (newValue) => {
  phoneNumber.value = newValue;
});
</script>

<style>
/* Adjust vue-tel-input to align nicely with Bootstrap form styling */
.vue-tel-input {
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  box-shadow: none;
}

.vue-tel-input:focus-within {
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  border-color: #86b7fe;
}

.vue-tel-input .form-control {
  border: none !important;
  box-shadow: none !important;
}

/* Style the search input inside the country dropdown list */
.vue-tel-input .vti__search_box {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 6px 10px;
  margin: 8px;
  width: calc(100% - 16px);
  /* keeps it nicely padded inside the menu */
  box-sizing: border-box;
}
</style>